import React from "react";

import { INTEGRATION_LOGO_WORDMARK_CLASS } from "../integrationLogoStyles";

export default function AsaasLogo({
	className = INTEGRATION_LOGO_WORDMARK_CLASS,
}) {
	return (
		<img
			src={`${process.env.PUBLIC_URL}/icons/asaas.svg`}
			alt="Asaas"
			className={className}
			draggable={false}
		/>
	);
}
